import blueBars from '../assets/images/colorBars/blueBars.svg';
import redBars from '../assets/images/colorBars/redBars.svg';
import purpleBars from '../assets/images/colorBars/purpleBars.svg';
import greenBars from '../assets/images/colorBars/greenBars.svg';
import orangeBars from '../assets/images/colorBars/orangeBars.svg';

export const COUNTRY_CODE = process.env.GATSBY_COUNTRY_CODE || 'en';
export const LANGUAGE = process.env.GATSBY_LANGUAGE || COUNTRY_CODE;
export const FACEBOOK_PIXEL_ID = process.env.GATSBY_FACEBOOK_PIXEL_ID;
export const FACEBOOK_DOMAIN_VERIFICATION_CODE =
  process.env.GATSBY_FACEBOOK_DOMAIN_VERIFICATION_CODE;
export const DOMAIN_SUFFIX = process.env.GATSBY_DOMAIN_SUFFIX || COUNTRY_CODE;

export const COUNTRY_TO_CAREER_LINK = {
  pt: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=Portugal&optionsFacetsDD_customfield1=Crop+Protection&optionsFacetsDD_customfield5=&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
  es: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=Spain&optionsFacetsDD_customfield1=Crop+Protection&optionsFacetsDD_customfield5=&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
  fr: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=France&optionsFacetsDD_customfield1=&optionsFacetsDD_customfield5=Ascenza+France&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
  it: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=Italy&optionsFacetsDD_customfield1=&optionsFacetsDD_customfield5=Ascenza+Italy&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
  mx: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=Mexico&optionsFacetsDD_customfield1=Crop+Protection&optionsFacetsDD_customfield5=&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
  br: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=Brazil&optionsFacetsDD_customfield1=Crop+Protection&optionsFacetsDD_customfield5=&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
  ro: 'https://careers.rovensa.com/search/?createNewAlert=false&q=&locationsearch=&optionsFacetsDD_customfield4=Romania&optionsFacetsDD_customfield1=&optionsFacetsDD_customfield5=Ascenza+Romania&optionsFacetsDD_customfield2=&optionsFacetsDD_customfield3=',
};

export const HIDDEN_FEATURES = [
  ...((
    {
      pt: ['ghsCodes'],
      es: ['distributors_page', 'distributors_homepage_search', 'useful_links_search'],
      fr: ['problem_filters', 'distributors_homepage_search', 'hide_blexia_top_bar_close_btn'],
      it: ['useful_links_search'],
      mx: ['distributors_page', 'distributors_homepage_search', 'useful_links_search'],
      br: ['distributors_homepage_search'],
      ro: ['distributors_page', 'distributors_homepage_search', 'useful_links_search'],
    } as Record<
      string,
      Array<
        | 'products'
        | 'distributors_page'
        | 'problem_filters'
        | 'distributors_homepage_search'
        | 'ghsCodes'
        | 'useful_links_search'
        | 'hide_blexia_top_bar_close_btn'
      >
    >
  )[COUNTRY_CODE] || []),
];

export const VISIBLE_FEATURES = [
  ...((
    {
      br: ['reserved_content_pop_up'],
    } as Record<string, Array<'reserved_content_pop_up'>>
  )[COUNTRY_CODE] || []),
];

export const PRODUCT_TYPE_COLOR_TO_BARS_IMAGE = {
  // WARNING
  // If you add/change a color here, then you should add/change it on the CMS too (cms/schemas/products/productType.js).
  '#336699': blueBars,
  '#ff3333': redBars,
  '#ad1aac': purpleBars,
  '#339933': greenBars,
  '#ff9900': orangeBars,
};

//  TODO: Add Nerthus link
export const NERTHUS_LINK = 'https://ascenza.com/nerthus';

export const NERTHUS_LINKS_ENABLED = process.env.GATSBY_NERTHUS_LINKS_ENABLED === 'true';

export const MEDIA_QUERIES_BREAK_POINTS = {
  smallPhone: 359,
  phone: 519,
  phablet: 767,
  tabletVertical: 959,
  tabletHorizontal: 1199,
  laptop: 1439,
};
